import {
	IApplicationCreate,
	IApplicationForm,
	IApplicationModel,
	IApplication,
	IApplicant,
	IHospital,
	IContactModelBasic,
	IContact,
	IAddress,
	IEmail,
	IPhone,
	ILink
} from "../../share/interfaces";

import { ApplicationStatusEnum } from "../../share/enums";

export interface IApplicationModel {
	ConvertToForm: () => IApplicationForm;
}

export class ApplicationModel implements IApplicationModel {
	ApplicantContactId: string;
	Application: IApplication;
	Links: ILink[];
	URL: string;
	Key: string;
	Status: number;
	StatusReason: string;
	ConvertToForm: () => IApplicationForm;
}

export class ApplicationCreateForm implements IApplicationCreate {
	Id: string;
	ParentId: string;
	ApplicantContactId: string;
	AccountId: string;
	Name: string;
	Level: number;

	ApplicationCreatedBy: IContactModelBasic;
	Applicant: IApplicant;
	Hospital: IHospital;
	ApplicationModifiedOn: Date;
	ApplicationModifiedBy: IContactModelBasic;
}

export interface IApplicationForm {
	ConvertToCreateModel: (userContact) => IApplicationCreate;
	SetApplicantContact: (applicantContaact: IContact) => void;
	GetApplication: (application: IApplicationForm) => void;
}

export class ApplicationForm implements IApplicationForm {
	Id: string;
	ParentId: string;
	ApplicantContactId: string;
	AccountId: string;
	AccountNumber: string;
	Name: string;
	Status: ApplicationStatusEnum;
	Level: number;

	ApplicantFirstName: string;
	ApplicantLastName: string;
	ApplicantFullName: string;
	ApplicantAddressLine1: string;
	ApplicantAddressLine2: string;
	ApplicantAddressCity: string;
	ApplicantAddressState: string;
	ApplicantAddressZip: string;
	ApplicantPhone: string;
	ApplicantPhoneType: string;
	ApplicantEmail: string;
	ApplicantPosition: string;

	HospitalName: string;
	CeoName: string;
	CeoId: string;
	CeoFirst: string;
	CeoLast: string;
	CeoEmail: string;
	CeoRole: string;
	HospitalAddressLine1: string;
	HospitalAddressLine2: string;
	HospitalAddressCity: string;
	HospitalAddressState: string;
	HospitalAddressCountry: string;
	HospitalAddressZip: string;
	HospitalPhone: string;
	HospitalCategoryId: string;

	ConvertToCreateModel: (userContact) => IApplicationCreate;
	SetApplicantContact: (applicantContact: IContact) => void;
	GetApplication: (application: IApplicationForm) => void;
}

export class ApplicationStatus {
	static ApplicationEnumToString(status: ApplicationStatusEnum) {
		return this.ToString(String(ApplicationStatusEnum[status]));
	}

	static ToString(s: string): string {
		s = s.replace("_", " ");
		return s;
	}

	static GetStatus(value: number): string {
		if (value == 8) {
			value = 12;
		}
		return this.ToString(ApplicationStatusEnum[value]);
	}

	static GetEnum(value: number): ApplicationStatusEnum {
		if (value == 8) {
			value = 12;
		}
		return <ApplicationStatusEnum>value;
	}

	static ToEnum(value: string): ApplicationStatusEnum {
		"ToEnum".logWithObject("toenum", value);
		if (value !== undefined) {
			const s = value.trim().replace(" ", "_");
			const e = ApplicationStatusEnum[s];
			return e;
		} else {
			return ApplicationStatusEnum.None;
		}
	}
}

ApplicationForm.prototype.GetApplication = function(app: IApplicationForm) {
	const a = <ApplicationForm>this;
	Object.keys(app).forEach(key => (a[key] = app[key]));
};

ApplicationForm.prototype.SetApplicantContact = function(
	applicantContact: IContact
) {
	this.ApplicantContactId = applicantContact.Id;
	this.ApplicantFirstName = applicantContact.Profile.FirstName;
	this.ApplicantLastName = applicantContact.Profile.LastName;
	this.ApplicantFullName = applicantContact.FullName;
	this.ApplicantPhone = applicantContact.PrimaryPhone.Num;
	this.ApplicantPosition = applicantContact.Profile.JobTitle;
	this.ApplicantEmail = applicantContact.Email1.Address;
	this.ApplicantAddressCity = applicantContact.Address1.City;
	this.ApplicantAddressZip = applicantContact.Address1.PostalCode;
	this.ApplicantAddressState = applicantContact.Address1.State;
};

ApplicationForm.prototype.ConvertToCreateModel = function(
	userContact: IContact
) {
	const form = <IApplicationForm>this;
	const currentDate = new Date();
	const user: IContactModelBasic = {
		AcepId: userContact.AcepId,
		FullName: userContact.FullName,
		Id: userContact.Id,
		CreatedOn: userContact.CreatedOn
	};
	const applicantAddress: IAddress = {
		City: form.ApplicantAddressCity,
		Line1: form.ApplicantAddressLine1,
		Line2: form.ApplicantAddressLine2,
		Name: "",
		PostalCode: form.ApplicantAddressZip,
		State: form.ApplicantAddressState,
		Country: ""
	};
	const applicantEmail: IEmail = {
		Address: form.ApplicantEmail,
		Name: ""
	};
	const applicantPhone: IPhone = {
		Num: form.ApplicantPhone,
		Name: form.ApplicantPhoneType
	};
	const applicant: IApplicant = {
		Address: applicantAddress,
		ContactId: form.ApplicantContactId,
		Email: applicantEmail,
		FirstName: form.ApplicantFirstName,
		FullName: form.ApplicantFullName,
		LastName: form.ApplicantLastName,
		Phone: applicantPhone,
		Position: form.ApplicantPosition
	};
	const hospitalAddress: IAddress = {
		City: form.HospitalAddressCity,
		Line1: form.HospitalAddressLine1,
		Line2: form.HospitalAddressLine2,
		Name: form.HospitalName,
		PostalCode: form.HospitalAddressZip,
		State: form.HospitalAddressState,
		Country: form.HospitalAddressCountry
	};
	const hospitalPhone: IPhone = {
		Name: "",
		Num: form.HospitalPhone
	};
	const hospital: IHospital = {
		AccountId: form.AccountId,
		AccountNumber: form.AccountNumber,
		Address: hospitalAddress,
		CeoName: form.CeoName,
		CeoId: form.CeoId,
		CeoFirst: form.CeoFirst,
		CeoLast: form.CeoLast,
		CeoEmail: form.CeoEmail,
		CeoRole: form.CeoRole,
		Name: form.HospitalName,
		Phone: hospitalPhone,
		CategoryId: form.HospitalCategoryId
	};

	const appId =
		form.Id === null || form.Id === undefined
			? "empy guid".EmptyGuid()
			: form.Id;
	const model: IApplicationCreate = {
		AccountId: form.AccountId,
		Applicant: applicant,
		ApplicantContactId: form.ApplicantContactId,
		ApplicationCreatedBy: user,
		ApplicationModifiedBy: user,
		ApplicationModifiedOn: currentDate,
		Hospital: hospital,
		Id: appId,
		ParentId: form.ParentId,
		Name: form.HospitalName,
		Level: form.Level
	};
	return model;
};

ApplicationModel.prototype.ConvertToForm = function() {
	const model = <ApplicationModel>this;
	const app = model.Application;
	const form: IApplicationForm = {
		AccountId: app.AccountId,
		AccountNumber: app.Hospital.AccountNumber,
		Id: app.Id,
		ParentId: app.ParentId,
		Name: app.Name,
		Status: model.Application.Status,
		Level: model.Application.Level,
		ApplicantAddressCity: app.Applicant.Address.City,
		ApplicantAddressLine1: app.Applicant.Address.Line1,
		ApplicantAddressLine2: app.Applicant.Address.Line2,
		ApplicantAddressState: app.Applicant.Address.State,
		ApplicantAddressZip: app.Applicant.Address.PostalCode,
		ApplicantContactId: app.Applicant.ContactId,
		ApplicantEmail: app.Applicant.Email.Address,
		ApplicantFirstName: app.Applicant.FirstName,
		ApplicantFullName: app.Applicant.FullName,
		ApplicantLastName: app.Applicant.LastName,
		ApplicantPhone: app.Applicant.Phone.Num,
		ApplicantPhoneType: app.Applicant.Phone.Name,
		ApplicantPosition: app.Applicant.Position,
		HospitalAddressCity: app.Hospital.Address.City,
		CeoName: app.Hospital.CeoName,
		CeoId: app.Hospital.CeoId,
		CeoFirst: app.Hospital.CeoFirst,
		CeoLast: app.Hospital.CeoLast,
		CeoEmail: app.Hospital.CeoEmail,
		CeoRole: app.Hospital.CeoRole,
		HospitalAddressLine1: app.Hospital.Address.Line1,
		HospitalAddressLine2: app.Hospital.Address.Line2,
		HospitalAddressZip: app.Hospital.Address.PostalCode,
		HospitalAddressState: app.Hospital.Address.State,
		HospitalAddressCountry: app.Hospital.Address.Country,
		HospitalName: app.Hospital.Name,
		HospitalPhone: app.Hospital.Phone.Num,
		HospitalCategoryId: app.Hospital.CategoryId
	};
	return form;
};



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/classes/application.class.ts